import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-chart',{staticClass:"fill-height",attrs:{"raw-data":_vm.periods,"chart-value-keys":[
    { key: 'CALETLDLHSR', label: _vm.$t('chart_legends.hsr_distance'), type: 'bar' },
    { key: 'UXPCSEEF', label: _vm.$t('chart_legends.of_explosive_efforts') }
  ],"x-value":"title","y-value-prefix":"teams[0].team_stats.","yaxis":[
    { title: { text: _vm.$t('chart_legends.hsr_distance') }},
    { title: { text: _vm.$t('chart_legends.explosive_efforts') }, opposite: true }
  ],"xaxis":{
    labels: {
      rotate: -45
    },
    tickPlacement: 'between'
  },"colors":[ '#FF4560', '#775DD0' ]},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c(VCardTitle,{staticClass:"pa-6"},[_c('div',{staticClass:"subtitle-2 grey--text text--grey-100"},[_vm._v(" "+_vm._s(_vm.$t('card_title.high_speed_running_and_explosive_efforts'))+" ")])])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }